export default "__VITE_ASSET__DixBcNzh__"